import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {  withRouter } from "react-router-dom";
import RegCarDetailsPopup from "./component";
import { setIsChangingPreFetchedDetail, setAllDetailFetchedCorrectly } from "../car-registration-number/actions";
import { setData, setStep, activateLastStep, activateFirstStep, showProceedButton, setAllStepFilled} from "../lead-form/actions";

const mapStateToProps = ({
    registrationNo: {
        userCarRegistrationNo,
        carRegistrationInfo,
        isRepeatInspection
    },
    leadData: {
        ownerName,
        brand,
        model,
        year,
        variant,
        fuelType,
        transmission,
        registrationState,
        rto
    },
    cities: {
        selectedCity
    },
    sellOnlineCities: {
        isSellOnline,
        applicableCityForSellOnline
    }

}) => ({
    isSellOnline,
    userCarRegistrationNo,
    ownerName,
    brand,
    model,
    year,
    variant,
    fuelType,
    transmission,
    registrationState,
    rto,
    selectedCity,
    applicableCityForSellOnline,
    carRegistrationInfo,
    isRepeatInspection
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setDataConnect: setData,
    setStepConnect: setStep,
    activateLastStepConnect: activateLastStep,
    showProceedButtonConnect: showProceedButton,
    setAllDetailFetchedCorrectlyConnect: setAllDetailFetchedCorrectly,
    setIsChangingPreFetchedDetailConnect: setIsChangingPreFetchedDetail,
    allStepFilledConnect: setAllStepFilled,
    activateFirstStepConnect: activateFirstStep
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegCarDetailsPopup));
